var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21006 8.57212H12.79C13.8662 8.57212 14.4038 7.24273 13.6448 6.46867L7.85703 0.361898C7.62053 0.120573 7.3115 0 7.00265 0C6.69401 0 6.38624 0.120573 6.15176 0.361898L0.355191 6.46957C-0.403738 7.24184 0.133654 8.57212 1.21006 8.57212ZM12.7874 11.4291H1.21006C0.133873 11.4291 -0.403782 12.758 0.355234 13.5325L6.15176 19.6393C6.38274 19.8795 6.65398 20 6.99958 20C7.30813 20 7.6173 19.8793 7.85397 19.638L13.6417 13.5312C14.4016 12.7594 13.8635 11.4291 12.7874 11.4291Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e8f41d1dfb1504505bd2295448025368.svg";
export { ForwardRef as ReactComponent };